var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"},[_c('span',{staticClass:"nav-link"},[_vm._v(" ")])])])])}]

export { render, staticRenderFns }